import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useForm } from "react-hook-form";
import { isWithdrawAvailableEndpoint, withdrawRequestUrl, getUserApiService } from "../Config";
import SuccessIcon from "../../../../../assets/svg/forms/success.inline.svg";
import UserIcon from "../../../../../assets/svg/forms/login.inline.svg";
import {
  getAuthHeader,
  getAuthToken,
  Logout
} from "../../../../Auth/Utils";
import EmojiIcons from "./EmojiIcons";

const WithdrawForm = ({gameName}) => {
  const {register, handleSubmit, watch, formState: {errors, isValid}} = useForm({mode: "onChange"});
  const [errorMsg, setErrorMsg] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const [apiMessage, setApiMessage] = useState('');
  const [ipAddress, setIpAddress] = useState('');
  const [allLoaded, setAllLoaded] = useState(false);

  const getUserIpAddress = async () => {
    const response = await fetch(getUserApiService, {
      method: 'GET',
    });
    if (response.ok) {
      let json = await response.json();
      if ("ip" in json) {
        setIpAddress(json.ip);
      }
    } else {
      console.log("Could not fetch ip " + response.status);
    }
  }

  const getInitialWithdrawStatus = async (ipAddress) => {
    if (!getAuthToken) {
      return false;
    }
    const checkIsAvailable = await fetch(isWithdrawAvailableEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getAuthHeader()
      },
      body: JSON.stringify({ip: ipAddress})
    });
    if (checkIsAvailable.ok) {
      let json = await checkIsAvailable.json();
      if ("message_thai" in json && json.message_thai) {
        setApiMessage(json.message_thai);
        setAllLoaded(true);
        if (json.error_type === 'session_expired') {
          Logout();
        }
      } else {
        setAllLoaded(true);
      }
    } else {
      console.log("Check is Withdraw available Error HTTP: " + checkIsAvailable.status);
      let json = await checkIsAvailable.json();
      if (json.code === 'jwt_auth_invalid_token') {
        Logout();
      }
    }
  }

  const hideServerError = () => {
    setErrorMsg('');
  }

  useEffect(() => {
    let mounted = true;
    if (!ipAddress) {
      getUserIpAddress().then(() => {
        console.log('Ip received');
      });
    } else {
      if (!allLoaded) {
        getInitialWithdrawStatus(ipAddress).then(() => {
          console.log('Initial Withdraw notification checked');
        })
      }
    }
    return () => {
      mounted = false;
    };
  }, [ipAddress]);

  const onSubmit = async (values) => {
    if (!getAuthToken) {
      return false;
    }
    let valuesObject = Object.assign({}, values);
    valuesObject.gclub_username = values.real_money === 'yes_acc' ? valuesObject.gclub_username : '';
    valuesObject.ip = ipAddress;
    delete valuesObject['real_money'];
    let body = JSON.stringify(valuesObject);

    const response = await fetch(withdrawRequestUrl, {
      method: 'POST',
      body: body,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getAuthHeader()
      },
    });
    if (response.ok) {
      let json = await response.json();
      if ("message_thai" in json && json.message_thai) {
        setIsSuccess(true);
        setApiMessage(json.message_thai);
      }
    } else {
      console.log("Withdraw Error HTTP: " + response.status);
      let json = await response.json();
      if (json.code === 'jwt_auth_invalid_token') {
        Logout();
      }
    }
  }

  let hasFsAccount = watch("real_money");

  return (
    <div className="popup-form-wrapper">
      <h3 className="a-center">ถอนเงิน</h3>
      {!allLoaded && <p className="withdraw-loading a-center">กำลังโหลดข้อมูล...</p>}
      {apiMessage ?
        <div className="success-block a-center">
          {isSuccess && <SuccessIcon/>}
          <div className="success-text a-center">
            <div dangerouslySetInnerHTML={{ __html: apiMessage }}/>
          </div>
        </div>
        :
        <form onSubmit={handleSubmit(onSubmit)} id="withdraw-form" className="a-center withdraw-form">
          <input type="hidden" value={gameName} {...register("game_name")}/>
          <input type="hidden" value={1} {...register("new_flow")}/>

          <p className="a-center top-notice">คุณมีบัญชีเงินจริง GCLUB ที่ใช้งานอยู่หรือไม่?</p>
          {errorMsg && <p className="error-msg">{errorMsg}</p>}

          <div className="has-real-money-wrap">
            <input
              type="radio"
              value={"yes_acc"}
              id="real_yes_acc"
              name="real_money"
              className="switcher"
              defaultChecked={true}
              {...register("real_money")}
            />
            <label htmlFor="real_yes_acc">ใช่</label>
            <input
              type="radio"
              value={"no_acc"}
              id="real_no_acc"
              name="real_money"
              className="switcher"
              {...register("real_money")}
            />
            <label htmlFor="real_no_acc">ไม่ใช่</label>
          </div>


          <div className={(hasFsAccount === "yes_acc") ? "field-wrap icon-field" : "field-wrap icon-field disabled"}>
            {errors.gclub_username && errors.gclub_username.type === "required" &&
            <div className="error">จำเป็นต้องใช้</div>
            }
            <input type="text"
                   disabled={hasFsAccount === "no_acc"} placeholder="ยูสเซอร์เนม เช่น Aoxxx000" onClick={hideServerError}
                   {...register("gclub_username", { required: hasFsAccount === "yes_acc" })}/>
            <UserIcon/>
          </div>

          <label className="small-label" htmlFor="comment">ความคิดเห็นของคุณ</label>
          <div className="field-wrap label-field">
            {errors.comment && errors.comment.type === "required" &&
            <div className="error">จำเป็นต้องใช้</div>
            }
            {errors.comment && errors.comment.type === "minLength" &&
            <div className="error">อย่างน้อย 100 ตัวอักษร</div>
            }
            <textarea placeholder="แสดงความคิดเห็นของคุณอย่างน้อย 100 ตัวอักษร" onClick={hideServerError}
                   {...register("comment", { required: true, minLength: 100 })}/>
          </div>

          <div className="rating-notice">ความรู้สึกของคุณ</div>

          <div className="emoji-wrap">
            <EmojiIcons/>
            <div className="inputs">
              <input
                type="radio"
                value="smiley"
                id="smiley"
                name="emoji"
                {...register("emoji")}
              />
              <label htmlFor="smiley"><span>5</span></label>
              <input
                type="radio"
                value="crazy"
                id="crazy"
                name="emoji"
                {...register("emoji")}
              />
              <label htmlFor="crazy"><span>4</span></label>
              <input
                type="radio"
                value="cowboy"
                id="cowboy"
                name="emoji"
                {...register("emoji")}
              />
              <label htmlFor="cowboy"><span>3</span></label>
              <input
                type="radio"
                value="devil"
                id="devil"
                name="emoji"
                {...register("emoji")}
              />
              <label htmlFor="devil"><span>2</span></label>
              <input
                type="radio"
                value="love"
                id="love"
                name="emoji"
                {...register("emoji")}
              />
              <label htmlFor="love"><span>1</span></label>
            </div>

          </div>

          <fieldset className="rating">
            {errors.rating && errors.rating.type === "required" &&
            <div className="error">จำเป็นต้องใช้</div>
            }
            <legend>Rating</legend>
            <input
              type="radio"
              value="5"
              id="star5"
              name="rating"
              {...register("rating", {required: true})}
            />
            <label htmlFor="star5"><span>5 stars</span></label>
            <input
              type="radio"
              value="4"
              id="star4"
              name="rating"
              {...register("rating")}
            />
            <label htmlFor="star4"><span>4 stars</span></label>
            <input
              type="radio"
              value="3"
              id="star3"
              name="rating"
              {...register("rating", {required: true})}
            />
            <label htmlFor="star3"><span>3 stars</span></label>
            <input
              type="radio"
              value="2"
              id="star2"
              name="rating"
              {...register("rating")}
            />
            <label htmlFor="star2"><span>2 stars</span></label>
            <input
              type="radio"
              value="1"
              id="star1"
              name="rating"
              {...register("rating", {required: true})}
            />
            <label htmlFor="star1"><span>1 stars</span></label>
          </fieldset>


          <div className="form-buttons flex">
            <button aria-label="ส่งความคิดเห็นและรับเงิน"
                    disabled={!isValid} type="submit">สส่งความคิดเห็นและรับเงิน</button>
          </div>
        </form>
      }
    </div>
  );
}

export default WithdrawForm;

WithdrawForm.propTypes = {
  gameName: PropTypes.string,
};
